module.exports = __webpack_public_path__ + "static/media/Illus-FoodOnItsWay@3x.2086b945.png";